// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__29Pb-","col":"styles_col__2WUcg"};